import React, {useCallback} from "react";
import {css} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";

import {ISearchFilter} from "../../types/ISearchFilters";
import {FilterCheckbox} from "./FilterCheckbox";

interface IProps {
    filter: ISearchFilter<string, string | number>;
    value?: number | string | (number | string)[];
    onChange: (name: string, value: (string | number)[]) => void;
}

export const FilterRadio = (props: IProps) => {
    const handleOnChange = useCallback(
        (name: string, isChecked: boolean, value: string | number) => {
            const selectedOptionValue = props.filter.filterOptions.filter((el) => el.value.toString() === value.toString())[0].value;

            if (isOptionSelected(selectedOptionValue)) {
                props.onChange(props.filter.id, []);
            } else {
                props.onChange(props.filter.id, [selectedOptionValue]);
            }
        },
        [props.filter, props.value, props.onChange]
    );

    const isOptionSelected = (filterValue: string | number) => {
        if (Array.isArray(props.value)) {
            return props.value.findIndex((singleValue) => singleValue.toString() === filterValue.toString()) !== -1;
        }

        return filterValue.toString() === props.value?.toString();
    };

    return (
        <>
            <div css={wrapperStyle}>
                {props.filter.filterOptions.map((filterOption) => (
                    <FilterCheckbox
                        key={filterOption.id}
                        filterId={props.filter.id}
                        filterOption={filterOption}
                        onChange={handleOnChange}
                        isChecked={isOptionSelected(filterOption.value)}
                        css={mb(1)}
                    />
                ))}
            </div>
        </>
    );
};

const wrapperStyle = css`
    display: flex;
    flex-direction: column;
    align-items: start;
    flex-shrink: 0;
    flex-grow: 0;
`;
import React, {useCallback} from "react";
import {css} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";

import {ISearchFilter} from "../../types/ISearchFilters";
import {FilterCheckbox} from "./FilterCheckbox";

interface IProps {
    filter: ISearchFilter<string, string | number>;
    value?: number | string | (number | string)[];
    onChange: (name: string, value: (string | number)[]) => void;
}

export const FilterRadio = (props: IProps) => {
    const handleOnChange = useCallback(
        (name: string, isChecked: boolean, value: string | number) => {
            const selectedOptionValue = props.filter.filterOptions.filter((el) => el.value.toString() === value.toString())[0].value;

            if (isOptionSelected(selectedOptionValue)) {
                props.onChange(props.filter.id, []);
            } else {
                props.onChange(props.filter.id, [selectedOptionValue]);
            }
        },
        [props.filter, props.value, props.onChange]
    );

    const isOptionSelected = (filterValue: string | number) => {
        if (Array.isArray(props.value)) {
            return props.value.findIndex((singleValue) => singleValue.toString() === filterValue.toString()) !== -1;
        }

        return filterValue.toString() === props.value?.toString();
    };

    return (
        <>
            <div css={wrapperStyle}>
                {props.filter.filterOptions.map((filterOption) => (
                    <FilterCheckbox
                        key={filterOption.id}
                        filterId={props.filter.id}
                        filterOption={filterOption}
                        onChange={handleOnChange}
                        isChecked={isOptionSelected(filterOption.value)}
                        css={mb(1)}
                    />
                ))}
            </div>
        </>
    );
};

const wrapperStyle = css`
    display: flex;
    flex-direction: column;
    align-items: start;
    flex-shrink: 0;
    flex-grow: 0;
`;
